export const MenuItems = [
    {
        title: 'Home',
        url: '/',
        icon:'fa-solid fa-house',
        cName:'nav-links'
    },
    {
        title: 'About',
        url: '/about',
        icon:'fa-solid fa-circle-info',
        cName:'nav-links'
    },
    {
        title: 'Service',
        url: '/service',
        icon:'fa-solid fa-bag-shopping',
        cName:'nav-links'
    },
    {
        title: 'Contact',
        url: '/contact',
        icon:'fa-solid fa-address-book',
        cName:'nav-links'
    },
    {
        title: 'SignUP',
        url: '/signup',
        cName:'nav-links-mobile'
    },
]